import styled from 'styled-components'

export const StyledIconBack = styled.img`
  width: 24px;
  height: 24px;
  z-index: 2;
  background-color: transparent;
  cursor: pointer;
`

export const StyledTokenListContainer = styled.div`
  margin: -22px -1rem 0;
  min-height: 70vh;
  max-height: 70vh;
  overflow: hidden auto;
`

export const StyledTabWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 17.5px;
`

export const StyledTabItem = styled.span`
  color: #191c1e;
  font-weight: normal;
  font-size: 13px;
  line-height: 24px;
  width: 60px;
  display: inline-block;
  text-align: center;
  position: relative;
  margin-bottom: 10px;
  margin-top: 13px;

  &::after {
    content: '';
    width: 14px;
    height: 2px;
    background: #191c1e;
    border-radius: 2px;
    position: absolute;
    bottom: -3px;
    left: 50%;
    transform: translateX(-50%);
  }
`

export const StyledSwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  color: #191c1e;
  cursor: pointer;
`

export const StyledIconSwitcher = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`

export const StyledTokenList = styled.div`
  padding: 0 16px;
`
